﻿// Import of creatApp from Vue 3 bundler.
import { createApp } from 'vue/dist/vue.esm-bundler';

// App imports.
import newsApp from './vue/news';
import eventsApp from './vue/events';
import profilesApp from './vue/profiles';
import projectsApp from './vue/projects';
import publicationsApp from './vue/publications';
import booksApp from './vue/books';

document.addEventListener('DOMContentLoaded', () => {
    // Mounting containers listing and DOM targeting.
    const $newsOverviewContainer = document.getElementById('news-overview');
    const $eventOverviewContainer = document.getElementById('event-overview');
    const $profileOverviewContainer = document.getElementById('profile-overview');
    const $projectOverviewContainer = document.getElementById('project-overview');
    const $publicationOverviewContainer = document.getElementById('publication-overview');
    const $bookOverviewContainer = document.getElementById('book-overview');

    const $newsWidgetContainers = document.querySelectorAll('.widget-news-highlight');
    const $eventWidgetContainers = document.querySelectorAll('.widget-event-highlight');
    const $profileWidgetContainers = document.querySelectorAll('.widget-profile');
    const $projectWidgetContainers = document.querySelectorAll('.widget-project');
    const $publicationWidgetContainers = document.querySelectorAll('.widget-publication');
    const $bookWidgetContainers = document.querySelectorAll('.widget-published-books');

    // For each app, only build the Vue instance if the targeted element is present and mount the app on the targeted element.
    if ($newsOverviewContainer) {
        createApp(newsApp).mount($newsOverviewContainer);
    }

    if ($eventOverviewContainer) {
        createApp(eventsApp).mount($eventOverviewContainer);
    }

    if ($profileOverviewContainer) {
        createApp(profilesApp).mount($profileOverviewContainer);
    }

    if ($projectOverviewContainer) {
        createApp(projectsApp).mount($projectOverviewContainer);
    }

    if ($publicationOverviewContainer) {
        createApp(publicationsApp).mount($publicationOverviewContainer);
    }

    if ($bookOverviewContainer) {
        createApp(booksApp).mount($bookOverviewContainer);
    }

    $newsWidgetContainers.forEach($container => {
        createApp(newsApp).mount($container);
    });

    $eventWidgetContainers.forEach($container => {
        createApp(eventsApp).mount($container);
    });

    $profileWidgetContainers.forEach($container => {
        createApp(profilesApp).mount($container);
    });

    $projectWidgetContainers.forEach($container => {
        createApp(projectsApp).mount($container);
    });

    $publicationWidgetContainers.forEach($container => {
        createApp(publicationsApp).mount($container);
    });

    $bookWidgetContainers.forEach($container => {
        createApp(booksApp).mount($container);
    });
});
